"use client";
import { Button } from "@/components/Core/Button";
import { validateNestedParams } from "@/helper/HelperFunction";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import OtpInput from "react-otp-input";
import classes from "./VerifyOtp.module.css";

const VerifyOtp = ({
  handleOtp,
  resendOtp,
  loading,
  resendOtpLoader,
  setCode,
  code,
}) => {
  const navigate = useNavigate();
  const [seconds, setSeconds] = useState(120);

  const validateOtp = async () => {
    const params = {
      code,
    };
    if (!validateNestedParams(params)) return;
    await handleOtp(params);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds(seconds - 1 > 0 ? seconds - 1 : "00");
    }, 1000);
    return () => clearInterval(interval);
  }, [seconds]);
  return (
    <>
      <div className={classes.formContainer}>
        <div className={classes.loginHeadingContainer}>
          <h6 className={classes.loginHeading}>Forget Password?</h6>
          <p>
            Email has been sent to your registered email address with a
            verification code.
          </p>
        </div>
        <form className={classes.loginForm}>
          <div>
            <OtpInput
              value={code}
              onChange={setCode}
              inputStyle={classes.OtpInput_style}
              numInputs={6}
              isInputNum={true}
              shouldAutoFocus={true}
              renderInput={(props) => <input {...props} />}
            />
            <p className={classes.resendContainer}>
              {seconds !== "00" && (
                <>
                  Your OTP code will expire in{" "}
                  <span className={classes.timer}>
                    {` ${String(Math.floor(seconds / 60)).padStart(
                      2,
                      "0"
                    )}:${String(seconds % 60).padStart(2, "0")}`}
                  </span>
                </>
              )}
              {seconds == "00" && (
                <>
                  Your OTP code has expired.
                  <span
                    onClick={async () => {
                      if (resendOtpLoader) return;
                      const res = await resendOtp();
                      if (res) setSeconds(120);
                    }}
                    className={classes.resend}
                  >
                    {resendOtpLoader ? "Sending..." : "Resend OTP"}
                  </span>
                </>
              )}
            </p>
          </div>
        </form>
        <Button
          className={classes.loginBtn}
          label={loading ? "wait..." : "Verify OTP"}
          onClick={validateOtp}
          disabled={loading || resendOtpLoader}
        />
        <p className={classes.forgetPass}>
          <span onClick={() => navigate("/login")}>Back To Login?</span>
        </p>
      </div>
    </>
  );
};

export default VerifyOtp;
